import styled from 'styled-components';

const Margin = styled.div`
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
`;

export default Margin;
